import './styles.scss';
import ProfileSideBar from 'app/molecules/ProfileSideBar';
import ProfilePersonalInfoPage from 'app/molecules/ProfilePersonalInfoPage';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from '../../../utils/utils';
import useGet from '../../../services/useGet';
import { Property } from '../../../types/property';

export const PROFILE_CONSTANTS = {
  PERSONAL_INFORMATION: {
    label: 'Personal Information',
    key: 'personal-information'
  },
  PASSWORD: {
    label: 'Password & Security',
    key: 'password'
  }
};

interface ProfileProps {
  user: any;
}

const Profile = ({ user }: ProfileProps) => {
  const [active, setActive] = useState(PROFILE_CONSTANTS.PERSONAL_INFORMATION.key);
  const options = [PROFILE_CONSTANTS.PERSONAL_INFORMATION, PROFILE_CONSTANTS.PASSWORD];

  const [profileData, getProfileData] = useGet<Property>({
    url: `/profile/${user?.attributes?.sub}`,
    defaultValue: {}
  });

  useEffect(() => {
    if (user && !isEmpty(user)) {
      //load user data
      getProfileData();
    }
  }, [user]);

  return (
    <div className="__profile-page font_lato">
      <div className="d-lg-flex d-block __main ">
        <ProfileSideBar active={active} setActive={setActive} options={options} />
        {profileData && <ProfilePersonalInfoPage active={active} setActive={setActive} profile={profileData} />}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.user
});

export default connect(mapStateToProps)(Profile);
